<template>
  <div v-if="isVisibleImageU" class="modal-overlay">
    <div class="modal-content">
      <h3 class="title">Editar Image</h3>
      <form @submit.prevent="submitImage">
        <div class="form-group">
          <label for="image_id">Identificador de la imagen</label>
          <input type="text" id="image_id" v-model="image_id" disabled />
        </div>

        <div class="form-group">
          <label for="pdf">Nueva Imagen </label>
          <input type="file" id="images" accept="image/jpeg, image/png, image/jpg" @change="handleFileChange" />
          <div v-if="imageFile" class="text-green">
            Archivo seleccionado: {{ image }}
          </div>
        </div>

        <div v-if="imageURL" class="crop-container">
          <vue-cropper ref="cropper" :src="imageURL" alt="Imagen seleccionada" :autoCropArea="1" :viewMode="1"
            style="max-height: 300px; width: 100%;" />
        </div>


        <div style="display: flex; justify-content: flex-end">
          <button type="submit" :disabled="dataSent" :class="{ 'btn-disabled': dataSent }">
            <span v-if="dataSent" class="spinner-button"></span>
            <span v-if="dataSent"> Subiendo... </span>
            <span v-else> Guardar cambios </span>
          </button>
          <button type="button" @click="closeModal">Cerrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "@/kernel/alerts";
import { updateSectionImage } from "../services/sections-service";
import imageCompression from "browser-image-compression";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';


export default {
  components: {
    VueCropper,
  },
  props: {
    isVisibleImageU: {
      type: Boolean,
      required: true,
    },
    imageSection: {
      type: String,
      default: "",
    },
    imageId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      imageFile: null,
      image_id: "",
      image: "",
      dataSent: false,
      imageURL: null,
    };
  },
  watch: {
    imageId(newVal) {
      if (newVal) {
        this.image_id = this.imageId;
      }
    },
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (
        (file && file.type === "image/jpeg") ||
        file.type === "image/jpg" ||
        file.type === "image/png"
      ) {
        try {
          const options = {
            maxSizeMB: 0.3,
            maxWidthOrHeight: 1024,
            useWebWorker: true,
            fileType: "image/jpeg",
          };

          const compressedBlob = await imageCompression(file, options);

          const compressedFile = new File([compressedBlob], file.name, {
            type: compressedBlob.type,
          });

          this.imageFile = compressedFile;
          this.image = file.name;
          this.imageURL = URL.createObjectURL(file);
        } catch (error) {
          showErrorToast("Error al comprimir la imagen.");
          console.error("Compression error:", error);
        }
      } else {
        showErrorToast(
          "Formato de archivo no válido. Solo se permiten imágenes JPEG y PNG."
        );
        this.imageFile = null;
        this.image = "";
      }
    },
    closeModal() {
      this.$emit("update:visible", false);
      this.imageFile = null;
      this.image = "";
      this.imageURL = null;

      if (this.$refs.cropper) {
        this.$refs.cropper.destroy(); // opcional si usas watch
      }
    },

    async submitImage() {
      this.dataSent = true;
      showInfoToast("Subiendo archivo...");

      if (!this.$refs.cropper || !this.image_id) {
        this.dataSent = false;
        showErrorToast("Por favor, selecciona una imagen válida.");
        return;
      }

      try {
        // obtener canvas recortado
        const canvas = this.$refs.cropper.getCroppedCanvas({
          maxWidth: 1024,
          maxHeight: 1024,
        });

        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.9)
        );

        const croppedFile = new File([blob], this.image, {
          type: "image/jpeg",
        });

        const formData = new FormData();
        formData.append("image", croppedFile);
        formData.append("image_name", this.image);
        formData.append("image_id", this.image_id);
        formData.append("page", this.imageSection);

        const result = await updateSectionImage(formData);
        if (result.status === 200) {
          showSuccessToast("Archivo actualizado correctamente.");
          this.$emit("update:files");
          this.dataSent = false;
          this.closeModal();
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
        showErrorToast("Ocurrió un error al subir la imagen.");
        this.dataSent = false;
      } finally {
        this.dataSent = false;
      }
    },

  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  max-width: 100%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

button {
  padding: 10px 15px;
  margin-top: 10px;
  cursor: pointer;
  background-color: orange;
  color: white;
  border: none;
  border-radius: 16px;
}

button[type="submit"]:hover {
  background-color: yellowgreen;
}

button[type="button"] {
  margin-left: 16px;
  background-color: darkgray;
}

button[type="button"]:hover {
  background-color: gray;
}

.title {
  margin-top: 0;
  color: orange;
}

.text-green {
  color: green;
  font-weight: bold;
  margin-top: 8px;
}

.spinner-button {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top: 2px solid #ffa500; /* naranja */
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.btn-disabled {
  background-color: #ccc !important;
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.6;
  color: black !important;
}
</style>
